var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-card"},[(_vm.title)?_c('b',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }